import React from 'react'

import { Accordion, Text, STATE } from '@interco/inter-toranja'
import { CONTENT_VARIANT } from '@interco/inter-toranja/dist/components/Molecules/Accordion/types'
import {
  TextType,
  TextSize,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'

import type { AccordionItem } from '../interfaces'
import * as S from './styles'

interface AccordionProps {
  items?: AccordionItem[]
}

export const AccordionComponent: React.FC<AccordionProps> = ({ items }) => (
  <>
    {items?.map((item) => (
      <S.ContainerAccordion key={item.id}>
        <Accordion
          title={item.title}
          description={item?.description}
          state={STATE.ENABLED}
          contentVariant={CONTENT_VARIANT.TEXT}
          showDivider
          showLeading={false}
        >
          <div>
            {item.content.components?.map((component) => {
              if (component.type === 'bullet_list') {
                return (
                  <ul key={component.id} style={{ marginLeft: 24, marginTop: 8 }}>
                    {component.props.items?.map((listItem) => (
                      <li
                        key={`${component.id}-item-${listItem.text}`}
                        style={{ color: 'var(--color-text-neutral-secondary)' }}
                      >
                        <Text
                          key={component.id}
                          textType={TextType.Body}
                          textSize={TextSize.Medium}
                          textWeight={TextWeight.Regular}
                          colorVariant="secondary"
                          data-testid="description"
                        >
                          {listItem.text}
                        </Text>
                      </li>
                    ))}
                  </ul>
                )
              }

              return (
                <Text
                  key={component.id}
                  textType={TextType.Body}
                  textSize={TextSize.Medium}
                  colorVariant="secondary"
                  textWeight={TextWeight.Regular}
                  data-testid="description"
                >
                  {component.props.text ?? ''}
                </Text>
              )
            })}
          </div>
        </Accordion>
      </S.ContainerAccordion>
    ))}
  </>
)
